export const participantGroupLabel = (t, group, plural) => {
  if (group === 'general_managers') {
    return plural
      ? t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.GENERAL_MANAGERS.PLURAL')
      : t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.GENERAL_MANAGERS.SINGULAR');
  }
  if (group === 'managers') {
    return plural
      ? t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.MANAGERS.PLURAL')
      : t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.MANAGERS.SINGULAR');
  }
  if (group === 'seller_brokers') {
    return plural
      ? t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.SELLER_BROKERS.PLURAL')
      : t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.SELLER_BROKERS.SINGULAR');
  }
  return plural
    ? t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.OPTIONIST_BROKERS.PLURAL')
    : t('SALES.COMMISSION.PARTICIPANTS.HEADINGS.OPTIONIST_BROKERS.SINGULAR');
};

export const participantArticle = (t, plural) =>
  plural
    ? t('SALES.COMMISSION.PARTICIPANTS.ARTICLES.PLURAL')
    : t('SALES.COMMISSION.PARTICIPANTS.ARTICLES.SINGULAR');

export const participantReportLabel = (t, type) => {
  if (type === 'simples')
    return t('SALES.COMMISSION.PARTICIPANTS.REPORT_TYPES.SIMPLES');
  if (type === 'com_chave')
    return t('SALES.COMMISSION.PARTICIPANTS.REPORT_TYPES.COM_CHAVE');
  if (type === 'exclusividade')
    return t('SALES.COMMISSION.PARTICIPANTS.REPORT_TYPES.EXCLUSIVIDADE');
  return t('SALES.COMMISSION.PARTICIPANTS.REPORT_TYPES.LANÇAMENTO');
};

export const commissionSectionLabel = (t, section) => {
  if (section === 'company') return t('SALES.COMMISSION.SECTIONS.COMPANY');
  if (section === 'installments')
    return t('SALES.COMMISSION.SECTIONS.INSTALLMENTS');
  if (section === 'general_managers')
    return t('SALES.COMMISSION.SECTIONS.GENERAL_MANAGERS');
  if (section === 'managers') return t('SALES.COMMISSION.SECTIONS.MANAGERS');
  if (section === 'seller_brokers')
    return t('SALES.COMMISSION.SECTIONS.SELLER_BROKERS');
  return t('SALES.COMMISSION.SECTIONS.OPTIONIST_BROKERS');
};
